import React, { Component } from 'react';
import { array, object, string } from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import CircularProgress from '@material-ui/core/CircularProgress';

import ActionBar from '../../components/ActionBar';
import ActionBarItem from '../../components/ActionBarItem';
import ErpAgentsTable from './ErpAgentsTable';
import DeleteErpAgentModal from '../Modals/DeleteErpAgentModal';
import NewErpAgentModal from '../Modals/NewErpAgentModal';
import NewErpAgentCredentialsModal from '../Modals/NewErpAgentCredentialsModal';
import RenameErpAgentModal from '../Modals/RenameErpAgentModal';
import RotateCredentialsModal from '../Modals/RotateCredentialsModal';

import EsmsPage from '../../components/EsmsPage';
import ElapsedTime from '../../components/ElapsedTime';

import { isAllowed } from '../../helpers/auth';
import { Permissions } from '../../helpers/permissions';

import * as ErpAgentActions from '../../actions/erpAgentActions';

import { progress, progressContainer } from '../../containers/Reporting/KnowiDashboard.module.css';

class ErpAgentsPage extends Component {
    static propTypes = {
        erpAgents:     array,
        companyInfo:   object,
        currentScopes: array,
        history:       object,
        location:      object,
        message:       string,
        updatedAt:     object
    }

    state = {
        agent:                           {},
        deleteErpAgentModalOpen:         false,
        newErpAgentModalOpen:            false,
        newErpAgentCredentialsModalOpen: false,
        renameErpAgentModalOpen:         false,
        rotateCredentialsModalOpen:      false
    }

    componentDidMount() {
    }

    handleToggleNewErpAgentModal = () => {
        this.setState(state => ({
            newErpAgentModalOpen: !state.newErpAgentModalOpen
        }));
    }

    handleToggleNewErpAgentCredentialsModal = () => {
        this.setState(state => ({
            newErpAgentCredentialsModalOpen: !state.newErpAgentCredentialsModalOpen
        }));
    }

    handleToggleRotateCredentialsModal = (agent = {}) => {
        this.setState(state => ({
            agent,
            rotateCredentialsModalOpen: !state.rotateCredentialsModalOpen
        }));
    };

    handleToggleDeleteErpAgentModal = (agent = {}) => {
        this.setState(state => ({
            agent,
            deleteErpAgentModalOpen: !state.deleteErpAgentModalOpen
        }));
    }

    handleToggleRenameErpAgentModal = (agent = {}) => {
        this.setState(state => ({
            agent,
            renameErpAgentModalOpen: !state.renameErpAgentModalOpen
        }));
    }

    handleDelete = (agent = {}) => {
        this.setState(state => ({
            agent,
            deleteErpAgentModalOpen: true
        }));
    }

    handleSort = (property) => {
        return (event)=> {
            this.props.reorderErpAgents(property);
        };
    }

    handlePageRoute = () => {
        const { history, location } = this.props;

        history.push('/iothub' + location.search);
    }

    renderTable() {
        let {
            erpAgents,
            companyInfo,
            currentScopes
        } = this.props;

        const isFullHubAllowed = isAllowed(currentScopes, Permissions('iothubFull'));

        return (
            <React.Fragment>
                <EsmsPage
                    parents={[companyInfo.companyName]}
                    handlers={[this.handlePageRoute]}
                    title="FSM Integrations"
                    subtitle={(
                        <ElapsedTime
                            dateTime={this.props.updatedAt}
                            render={(time) => `Updated ${time}`}
                        />
                    )}
                >
                    <ActionBar>
                        <ActionBarItem
                            onClick={this.handleToggleNewErpAgentModal}
                            hidden={!isFullHubAllowed}
                            type="add"
                        >
                            New Integration
                        </ActionBarItem>
                    </ActionBar>
                    <ErpAgentsTable
                        agents={erpAgents}
                        companyInfo={companyInfo}
                        isFullHubAllowed={isFullHubAllowed}
                        onDeleteModal={this.handleDelete}
                        onSort={this.handleSort}
                        onRenameAgentModal={this.handleToggleRenameErpAgentModal}
                        onRotateCredentialsModal={this.handleToggleRotateCredentialsModal}
                    />
                </EsmsPage>
                <NewErpAgentModal
                    open={this.state.newErpAgentModalOpen}
                    close={this.handleToggleNewErpAgentModal}
                    title="New FSM Integration"
                    toggleCredentialsModal={this.handleToggleNewErpAgentCredentialsModal}
                />
                <NewErpAgentCredentialsModal
                    open={this.state.newErpAgentCredentialsModalOpen}
                    close={this.handleToggleNewErpAgentCredentialsModal}
                    title="Integration Credentials"
                />
                <DeleteErpAgentModal
                    open={this.state.deleteErpAgentModalOpen}
                    close={this.handleToggleDeleteErpAgentModal}
                    title={`Delete Integration Configuration: ${this.state.agent.name}`}
                />
                <RenameErpAgentModal
                    open={this.state.renameErpAgentModalOpen}
                    close={this.handleToggleRenameErpAgentModal}
                    agent={this.state.agent}
                    title={`Rename Agent ${this.state.agent.name}`}
                />
                <RotateCredentialsModal
                    agent={this.state.agent}
                    isOpen={this.state.rotateCredentialsModalOpen}
                    handleClose={this.handleToggleRotateCredentialsModal}
                />
            </React.Fragment>
        );
    }

    render() {
        if (this.props.isLoading) {
            return (
                <div className={progressContainer}>
                    <CircularProgress
                        className={progress}
                        size={50}
                    />
                </div>
            );
        }
        return this.renderTable();
    }


}

export const mapStateToProps = state => {
    const { erpAgents, erpAgentsLoading, updatedAt } = state.erpAgent;
    return {
        companyInfo:   state.companyInfo,
        currentScopes: state.core.currentScopes,
        isLoading:     erpAgentsLoading,
        message:       state.messages.message,
        erpAgents,
        updatedAt
    };
};

const mapDispatchToProps = {
    ...ErpAgentActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ErpAgentsPage));
